import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Clock, ArrowUpRight } from "lucide-react";
import { levelStyle } from "@/lib/constants";

export function WorkshopCard({ workshop, index = 0 }) {
  const s = levelStyle(workshop.level);
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.4, delay: (index % 4) * 0.08 }}
    >
      <Link
        to={`/nos-activites/${workshop.id}`}
        data-testid={`workshop-card-${workshop.id}`}
        className="group block bg-white rounded-3xl border border-slate-100 shadow-sm hover:shadow-xl hover:shadow-sky-500/10 hover:-translate-y-1 transition-[transform,box-shadow] duration-300 overflow-hidden h-full"
      >
        <div className="relative h-48 overflow-hidden">
          <img
            src={workshop.image}
            alt={workshop.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <span className={`absolute top-3 left-3 inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold ${s.bg} ${s.text}`}>
            <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} /> {s.label}
          </span>
        </div>
        <div className="p-6">
          <span className="text-xs font-bold uppercase tracking-[0.15em] text-slate-400">
            {workshop.competence}
          </span>
          <h3 className="font-heading font-extrabold text-xl text-slate-900 mt-1 mb-2 group-hover:text-sky-600 transition-colors">
            {workshop.title}
          </h3>
          <p className="text-sm text-slate-500 line-clamp-2 mb-4">{workshop.summary}</p>
          <div className="flex items-center justify-between">
            <span className="inline-flex items-center gap-1.5 text-sm text-slate-500 font-medium">
              <Clock className="w-4 h-4" /> {workshop.duration}
            </span>
            <span className="inline-flex items-center gap-1 text-sky-600 font-bold text-sm">
              Voir détail <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
